import { render, staticRenderFns } from "./SubscribePinsGraph.vue?vue&type=template&id=8f20e8d2&scoped=true"
import script from "./SubscribePinsGraph.vue?vue&type=script&lang=js"
export * from "./SubscribePinsGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f20e8d2",
  null
  
)

export default component.exports